"use client"

import { Button } from "@/components/ui/button"
import { Card, CardContent } from "@/components/ui/card"
import { useDemoModal } from "@/components/demo-modal-provider"

export function ProductTieIn() {
  const { openDemoModal } = useDemoModal()

  return (
    <section className="py-20 bg-[#000000] relative overflow-hidden">
      {/* Subtle background accents for depth */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-24 -left-24 w-72 h-72 rounded-full bg-white/15 blur-3xl" />
        <div className="absolute -bottom-24 -right-24 w-72 h-72 rounded-full bg-black/10 blur-3xl" />
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative">
        <Card className="max-w-4xl mx-auto relative animated-border overflow-hidden rounded-3xl bg-black/60 backdrop-blur-xl border border-white/30 shadow-xl hover:shadow-2xl transition-all">
          <CardContent className="p-10 md:p-12 text-center relative">
            {/* Light glow accents inside card */}
            <div className="absolute inset-0 -z-0 pointer-events-none">
              <div className="absolute -top-20 left-1/3 w-48 h-48 bg-[#1a85ca]/10 rounded-full blur-2xl" />
              <div className="absolute -bottom-16 right-1/4 w-56 h-56 bg-[#EA3056]/10 rounded-full blur-2xl" />
            </div>

            <h2 className="text-3xl lg:text-4xl font-light text-gray-500 mb-4">
              Run a Smarter, AI-Powered HMO with OctoHealth ERP
            </h2>
            <p className="text-base sm:text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
              Power your HMO with an all-in-one ERP that simplifies everything from claims and underwriting to
              authorizations and pharmacy benefits.
            </p>

            {/* Centralized single CTA button with sheen */}
            <div className="flex justify-center">
              <Button
                size="lg"
                className="relative group overflow-hidden bg-[#1a85ca] hover:bg-[#0630a0] text-white text-lg px-8 py-3 rounded-full border shadow-lg hover:shadow-xl transition-all bg-transparent"
                onClick={openDemoModal}
              >
                <span className="relative z-10">Request a Demo</span>
                <span className="absolute inset-0 -translate-x-full group-hover:translate-x-0 transition-transform duration-700 ease-out bg-gradient-to-r from-white/0 via-white/30 to-white/0" />
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>
  )
}
